<template>
  <v-container>
    <v-row class="text-center">
      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-5">
          {{ $t('Explanation') }}
        </h2>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <v-card class="mx-auto pa-4" max-width="760">
          <div class="d-flex align-center justify-center flex-wrap ga-3">
            <v-btn color="primary" :loading="backendCheckLoading" @click="checkMesskursBackend">
              {{ $t('Messkurs API/DB testen') }}
            </v-btn>
            <v-chip v-if="backendCheckDone" :color="backendOk ? 'success' : 'error'">
              {{ backendOk ? $t('API + DB OK') : $t('Fehler') }}
            </v-chip>
          </div>
          <div v-if="backendMessage" class="mt-3 text-body-2">
            {{ backendMessage }}
          </div>
          <div v-if="backendEndpoint" class="mt-1 text-caption">
            {{ backendEndpoint }}
          </div>
        </v-card>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-5">
          {{ $t('Links') }}
        </h2>

        <v-row justify="center">
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MesskursBackendService from '@/services/MesskursBackendService';

export default {
  name: 'HomeComponent',
  data() {

    return {
      backendCheckLoading: false,
      backendCheckDone: false,
      backendOk: false,
      backendMessage: '',
      backendEndpoint: '',
      importantLinks: [
        {
          text: 'C-Learning',
          href: 'https://www.c-learning.com',
        },
        {
          text: this.$t('Help'),
          href: 'https://www.c-learning.com/support-messkurs-metalltechnik/',
        },
      ],
    };
  },
  methods: {
    async checkMesskursBackend() {
      this.backendCheckLoading = true;
      this.backendCheckDone = false;
      this.backendOk = false;
      this.backendMessage = '';
      this.backendEndpoint = '';

      try {
        const response = await MesskursBackendService.healthDeep();
        this.backendCheckDone = true;
        this.backendOk = response?.status === 'ok' && response?.api === true && response?.database === true;
        this.backendMessage = this.backendOk
          ? this.$t('Verbindung erfolgreich: API und MongoDB erreichbar.')
          : this.$t('Antwort erhalten, aber nicht vollständig OK.');
      } catch (error) {
        const responseData = error?.response?.data;
        this.backendCheckDone = true;
        this.backendOk = false;
        this.backendMessage = responseData?.message || this.$t('Backend nicht erreichbar oder Datenbank nicht verbunden.');
      } finally {
        this.backendCheckLoading = false;
        this.backendEndpoint = `${process.env.VUE_APP_MESSKURS_API_URL || 'http://127.0.0.1:3010'}/api/health/deep`;
      }
    }
  }
}
</script>
